module.exports = __webpack_public_path__ + "img/按钮1.81b69dfd.png";